<template>
  <b-button
    variant="warning"
    @click="update"
    class="mr-2"
  >

    <b-icon
      icon="arrow90deg-up" />
    更新
  </b-button>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'user/edit'
    }
  },

  computed: {
    updatable () {
      return this.$store.getters[`${this.modelName}/updatable`]
    }
  },

  methods: {
    async update () {
      if (!this.updatable) return

      this.$store.dispatch('loading/show')
      const result = await this.$store.dispatch(`${this.modelName}/update`)
      this.$store.dispatch('loading/hide')

      if (result) {
        this.$store.dispatch('toast/show', {
          content: 'メンバー情報を更新しました。',
          title: 'メンバー情報の更新'
        })
        this.$router.back(-1)
      }
    }
  }
}
</script>
